import axios from "axios";
import config from "./config";

export const signOut = () => {
  return axios.post("/users/sign_out", {}, config);
}
